export default "__VITE_ASSET__BUJ0b04k__"